export default __webpack_public_path__ + "locales/vi/ResetApplicationDialog.json?hash=6d0631d3722088e4f88ca699e040d968";